import React, { Component } from 'react';
import { sendHelpScript } from '../actions';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    return ({
        helpScript: state.convo.meta.helpScript
    });
}

class ModeratorAdvice extends Component {
    constructor(props) {
        super(props);
        this.generateText = this.generateText.bind(this);

        this.advices = ["Here’s a tip on how to build trust with someone you disagree with, from Thich Nhat Hanh, a Vietnamese Buddhist Monk who teaches the art of fighting. Try sharing at least three positive qualities you have observed in the person you are interacting with. Be specific. Do this before expressing where you are at odds.",
        "This conversation is getting heated. The purpose of this interaction is to build empathy and understanding of different viewpoints. Before typing your next responses, consider engaging in some deep abdominal breathing.",
        "According to Thich Nhat Hanh, a well known zen teacher, deep listening is a great way to understand a different viewpoint. Listen without judging or reacting. Listen without prejudice. “We have to practice listening to the pain of other people.” One way to do this is ask follow-up questions of the person you are conversing with before offering your opinion to understand their viewpoint more deeply."];

        this.buttonText = "Is the discussion getting heated?";
        this.footNote = "Click for a suggestion on how to resolve the tension for a constructive, civilized discussion.";
    }

    generateText(event) {
        console.log("triggered generate advice button");
        let choice = this.advices[Math.floor(Math.random() * this.advices.length)];
        this.props.dispatch(sendHelpScript(choice));
    }

    render() {

        return (
            <div class="helpScript">
                <div class="container">
                    <p>{this.props.helpScript}</p>
                </div>
                <button onClick={this.generateText}>{this.buttonText}</button>
                <p>{this.footNote}</p>
            </div>
        );
    }

}

export default connect(mapStateToProps)(ModeratorAdvice);


// WEBPACK FOOTER //
// ./src/components/ModeratorAdvice.js